import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import * as CONST from '../../../app/constants'
import { currentAgentApplicationSelector } from '../../../redux/selector/collectorApplicationSelector';
import { fullName } from "../../../app/utils";
import { Button, Header, Paragraph } from '../../../components/RegularComponents';
import TopNavigationBar from '../../TopNavigationBar';
import { applicationTypeFromLicenceSubType } from '../../../redux/slice/applicationsUtils';
// import { agencyApplicationSelector } from '../../../redux/selector/agencyApplicationSelector';
import { push } from 'connected-react-router';

export const MraRenewalBrokerContinuingEducationConfirmation = (props) => {
    // const { isModal = false, onEditSave = () => {}, nextUrl } = props;

    const dispatch = useDispatch();
    const applicationMode = CONST.APPLICATION_MODE_RENEW;
    const agentApplication = useSelector(currentAgentApplicationSelector);

    let applicationType = CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE
    
    if(agentApplication) { 
      const { licencingSubType } = agentApplication;
      applicationType = applicationTypeFromLicenceSubType(licencingSubType);
    }

    const isAMBApplication = (applicationType === CONST.APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE)
    const agentName = fullName(agentApplication?.businessLicenceData?.personData)
    const handleNext = (needCertificate) => () => {
        const noPath = CONST.ROUTE_PATH.MRA_RENEWAL_PRINCIPAL_BROKER_ACT_REGULATION_CONFIRMATION
        const yesPath = CONST.ROUTE_PATH.MRA_RENEWAL_BROKER_CONTINUING_EDUCATION_CERTIFICATE
        dispatch(push(`${CONST.ROUTE_PATH.MRA_APP}${needCertificate ? yesPath : noPath}`));
    };

    const headerText = `${isAMBApplication ? "Associate Mortgage Broker" : "Mortgage Broker " } Continuing Education`
    const paraText1 = `${isAMBApplication ? "Associate Mortgage brokers" : "Mortgage brokers " } renewing their licence are required to successfully complete an education program ${isAMBApplication ? "" : "and a regulatory information program"} in the 2 years immediately before the date of renewal.`
    const paraText2 = `As principal broker, it is your responsibility to provide completion date${isAMBApplication ? "" : "s for both"} and a copy
                            of the MPC continuing education certificate upon renewal of licences for each of your 
                            ${isAMBApplication ? "associate mortgage brokers" : "mortgage brokers" }.`

    return (
        <div className="container">
            <TopNavigationBar  {...props} applicationType={applicationType} applicationMode={applicationMode} />
            <div className="row">
              <div className="col-xs-12 col-lg-9">
                <Header
                    style={{ paddingBottom: "30px" }}
                    id="broker-education-confirmation-header"
                    header={headerText}
                />
                <Paragraph 
                    id="broker-education-confirmation-text"
                    text={[
                        // @no-multi-str
                        paraText1,
                        paraText2,
                        `Does ${agentName} need to complete continuing education to be compliant with the MRA this year?`
                    ]}
                />
              </div>
            </div>
            {/* Yes/No Answer */}
            <div className="row">
                <div className="col-lg-2 ">
                    <Button
                        className='ns-btn-yes-no'
                        buttonType="regular_primary"
                        onClick={handleNext(true)}
                        text={"Yes"}
                    />
                </div>
                <div className="col-lg-3">
                    <Button
                        className='ns-btn-yes-no'
                        buttonType="regular_primary"
                        onClick={handleNext(false)}
                        value={false}
                        text={"No"}
                    />
                </div>
            </div>
        </div>
    )
}
